import {
  definitions,
  operations,
  paths,
} from "../../common-fetch/generated/orders-model-api";
import { fetchItJson } from "../../common-fetch/miscellaneous/fetchItJson";
import { FetchOutput } from "../../common-fetch/miscellaneous/fetchResult";
import { getPartnerPathnameClient } from "../../getPartnerPathnameClient";

type Path = paths["/products/pricing/lookup"];
type Responses = Path["post"]["responses"];

export type FetchPostProductsPricingLookupInput =
  operations["PricingInfoPost"]["parameters"]["body"]["body"];

export type FetchPostProductsPricingLookupOutput = FetchOutput<
  Responses["200"]["schema"],
  definitions["ProblemDetails"]
>;

export async function fetchPostProductsPricingLookup(
  body: FetchPostProductsPricingLookupInput
): Promise<FetchPostProductsPricingLookupOutput> {
  const path: keyof paths = "/products/pricing/lookup";

  return fetchItJson<Responses["200"]["schema"], definitions["ProblemDetails"]>(
    "authorization",
    `${getPartnerPathnameClient(true)}/Market/HostedCart/Orders/v1${path}`,
    {
      method: "POST",
      body: JSON.stringify(body),
      headers: { "Content-Type": "application/json" },
    }
  ).catch(() => {
    return { tag: "client-error", parsed: { status: 418 } };
  });
}
